import React from "react";
import {
  ArrowUpRight,
  Bot,
  Database,
  Layers,
  LayoutDashboard,
  Map,
  Server,
  ShoppingBag,
  Smartphone,
  Upload,
} from "lucide-react";
import { produitsLizpack } from "../data/mockData";

const icones = {
  Layers,
  Upload,
  LayoutDashboard,
  Smartphone,
  Map,
  ShoppingBag,
  Database,
  Server,
};

const libelleLien = (lien) => lien.replace(/^https:\/\//, "").replace(/\/$/, "");

const familles = [
  {
    nom: "LizPack",
    resume:
      "Notre plateforme d'hébergement, de collecte terrain et de diffusion de données géospatiales.",
    lien: "https://lizpack.com",
    produits: produitsLizpack.map((p) => ({ ...p, icon: icones[p.icon] })),
  },
  {
    nom: "Toolboxes",
    resume: "Nos outils ouverts pour accélérer le travail quotidien en SIG.",
    produits: [
      {
        icon: Bot,
        nom: "QGIS MCP",
        desc: "Pilotez QGIS depuis un assistant IA : couches, traitements, mises en page.",
        lien: "https://qgismcp.geodonnee.com/",
      },
    ],
  },
];

/** Carte produit entièrement cliquable : la carte elle-même est le lien. */
const CarteProduit = ({ icon: Icon, nom, desc, lien }) => (
  <a href={lien} target="_blank" rel="noopener noreferrer" className="card">
    <Icon className="card-ico" strokeWidth={1.8} aria-hidden="true" />

    <h4 className="text-vt-h3 font-bold text-brand">{nom}</h4>
    <p className="mt-2 flex-1 leading-relaxed text-t2">{desc}</p>

    <span className="mt-5 inline-flex items-center gap-1.5 break-all text-vt-controle font-bold text-brand">
      {libelleLien(lien)}
      <ArrowUpRight
        className="h-[1.0625rem] w-[1.0625rem] flex-none"
        strokeWidth={2.4}
        aria-hidden="true"
      />
      <span className="sr-only">(nouvel onglet)</span>
    </span>
  </a>
);

export const Produits = () => (
  <section id="produits" className="section section-alt">
    <div className="shell">
      <div className="mx-auto max-w-[840px] text-center">
        <h2 className="h2">
          Nos <em>produits</em>
        </h2>
        <p className="lede mt-6">
          Les logiciels que nous développons et opérons, en complément de nos
          mandats de services.
        </p>
      </div>

      <div className="mt-10 lg:mt-12 space-y-10">
        {familles.map((famille) => (
          <div key={famille.nom}>
            <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-2 border-b border-border pb-5">
              <div>
                <h3 className="font-display text-vt-h3 font-extrabold text-brand">
                  {famille.nom}
                </h3>
                <p className="mt-1 text-t2">{famille.resume}</p>
              </div>

              {famille.lien && (
                <a
                  href={famille.lien}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-vt-controle font-bold text-brand"
                >
                  {libelleLien(famille.lien)}
                  <ArrowUpRight
                    className="h-[1.125rem] w-[1.125rem]"
                    strokeWidth={2.4}
                    aria-hidden="true"
                  />
                  <span className="sr-only">(nouvel onglet)</span>
                </a>
              )}
            </div>

            <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {famille.produits.map((produit) => (
                <CarteProduit key={produit.nom} {...produit} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
